<div class="d-flex flex-column min-vh-100 ">

<app-header-emvs *appReloadDirective="reloadHeader" ></app-header-emvs>

<router-outlet></router-outlet>
<div *ngIf="this.location.path() == ''">
    <app-login></app-login>
</div>
</div>
